// IMP-201: /Admin 경로 판별 — prefix-collision(/AdminFake 가 /Admin 으로 오인) 차단.
// 기존 pathname.startsWith('/Admin') 의 보안 약점(BUG-077 Admin 가드 우회) 교정.
export const isAdminPathname = (pathname) =>
    typeof pathname === 'string' &&
    (pathname === '/Admin' || pathname.startsWith('/Admin/'));
